import { render, staticRenderFns } from "./AddInsure.vue?vue&type=template&id=04ccb519&scoped=true&"
import script from "./AddInsure.vue?vue&type=script&lang=js&"
export * from "./AddInsure.vue?vue&type=script&lang=js&"
import style0 from "./AddInsure.vue?vue&type=style&index=0&id=04ccb519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ccb519",
  null
  
)

export default component.exports